import React, { useState, useEffect } from "react";
import FormInputStyle4 from "../../UIElements/FormInput";
import FormSelectStyle4 from "../../UIElements/FormSelect";
import CustomCheckbox from "../customCheckBox/customCheckBox";
import FormButtonStyle4 from "../../UIElements/FormButton";
import callApi from "../../../../utility/apiCaller";
import { setUserClickData } from "../../../../utility/setUserClickData";
import { toast } from "react-toastify";

import { useSearchParams } from "react-router-dom";
import axios from "axios";

function PersonalDetailsForm({
  isFormStarted,

  currentStep,
  setCurrentStep,

  formData,
  setFormData,
}) {
  const [gender, setGender] = useState("");
  const [name, setName] = useState("");
  const [errors, setErrors] = useState({});
  const [mobile, setMobile] = useState("");
  const [isMobileValid, setIsMobileValid] = useState(true);
  const [email, setEmail] = useState("");
  const [source, setSource] = useState("");
  const [utmSource, setUtmSource] = useState("");
  const [utmMedium, setUtmMedium] = useState("");
  const [affId, setAffId] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [pancard, setPan] = useState("");
  const [isPanValid, setIsPanValid] = useState(true);
  const [pincode, setPincode] = useState("");
  const [professionType, setprofessionType] = useState("");
  const [showErrors, setShowErrors] = useState(false);
  const [checked, setChecked] = useState(true);
  const [isFormValid, setIsFormValid] = useState(false);
  const [isConsentChecked, setIsConsentChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [dob, setDob] = useState();
  const [searchParams] = useSearchParams();
  const lid = searchParams.get("lid"); // ?lid=66bb77376073b363b8c6d9ee
  const [params] = useSearchParams();

  const handleMobileChange = (event) => {
    const value = event.target.value;

    if (/^\d*$/.test(value)) {
      setMobile(value);
      setFormData((prev) => ({
        ...prev,
        mobile: value,
      }));
    }

    // Always validate live
    setIsMobileValid(value.length === 10);
  };

  useEffect(() => {
    const fetchLeadData = async () => {
      try {
        if (!lid) return;

        const response = await callApi(
          "v1/lead/list",
          "post",
          {
            filters: { _id: lid },
          },
          "core" // using core service
        );

        const lead = response?.data?.leadList?.[0];
        console.log(lead); // assuming API returns array of leads

        if (lead) {
          setName(lead?.contact_name || "");
          setMobile(lead?.contact_phone || "");
          setEmail(lead?.contact_email || "");
          setGender(lead?.gender || "");
          setPan(lead?.pancard || "");
          setPincode(lead?.pincode || "");
          setprofessionType(lead?.profession_type || "");
          const formattedDate = new Date(lead.dob).toISOString().split("T")[0];
          setDob(formattedDate);

          // Update the overall formData too
          setFormData((prev) => ({
            ...prev,
            name: lead.contact_name || "",
            mobile: lead.contact_phone || "",
            email: lead.contact_email || "",
            gender: lead.gender || "",
            pancard: lead.pancard || "",
            pincode: lead.pincode || "",
            professionType: lead.profession_type || "",
            dob:lead.dob
          }));
        }
      } catch (error) {
        console.error("Failed to fetch lead data:", error);
      }
    };

    fetchLeadData();
  }, [setFormData]);

  const handleEmailChange = (event) => {
    const value = event.target.value.trim();

    setEmail(value);
    setFormData((prev) => ({
      ...prev,
      email: value,
    }));

    // Always validate live
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setIsEmailValid(emailRegex.test(value));
  };

  const handlePanChange = (e) => {
    const value = e.target.value.toUpperCase();
    setPan(value);

    // Always validate live
    const isValid = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value);
    setIsPanValid(isValid || value.length < 10); // only invalid if length = 10 & pattern fails
  };

  const handleProfessionChnage = (value) => {
    console.log(value);
    setprofessionType(value);
    if (errors.professionType) {
      setErrors((prev) => ({ ...prev, professionType: false }));
    }
  };

  console.log("Personal formData:", formData);
  useEffect(() => {
    if (params.get("source")) setSource(params.get("source"));
    if (params.get("utm_source")) setUtmSource(params.get("utm_source"));
    if (params.get("utm_medium")) setUtmMedium(params.get("utm_medium"));
    if (params.get("aff_id")) setAffId(params.get("aff_id"));
  }, [params]);

  useEffect(() => {
    console.log("=== Validation Check ===");
    console.log("gender:", !!gender);
    console.log("name:", !!name.trim());
    console.log("email:", /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email));
    console.log("pincode:", /^\d{6}$/.test(pincode));
    console.log("professionType:", !!professionType);
    console.log("pancard:", !!pancard);
    console.log("isPanValid:", isPanValid);
    console.log(isConsentChecked);

    const allValid =
      gender &&
      name.trim() &&
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) &&
      /^\d{6}$/.test(pincode) &&
      professionType &&
      pancard &&
      isPanValid &&
      isConsentChecked;

    setIsFormValid(allValid);
  }, [
    gender,
    name,
    email,
    pincode,
    professionType,
    pancard,
    isPanValid,
    isConsentChecked,
  ]);

  useEffect(() => {
    if (formData) {
      setGender(formData.gender || "");
      setName(formData.name || "");
      setMobile(formData.mobile || "");
      setPan(formData.pancard || "");
      setEmail(formData.email || "");
      setPincode(formData.pincode || "");
      setprofessionType(formData.professionType || "");
      // setIpAddress(ipAddress);
    }
  }, []);

  const handleConsentChange = async () => {
    setIsConsentChecked((prev) => {
      const newValue = !prev;
      console.log("Old:", prev, "New:", newValue);
      return newValue;
    });
  };
  const handleValidateAndUpdateForm = () => {
    // Step 1: Validate form
    if (!handleValidation()) {
      return;
    }

    // Step 2: Check consent
    if (!isConsentChecked) {
      toast.error("Please agree to the Terms and Conditions.");
      return;
    }

    setUserClickData({
      event_name: "personal-details-form-submit-for-old-lead-campaign",
      utm_source: utmSource|| utmMedium,
      user_id: formData.mobile || "No User ID found here",
      affiliate_id: params.get("aff_id") || "No Aff_id found",
    });

    // Step 3: Update form data
    setFormData((prev) => ({
      ...prev,
      gender,
      pancard,
      name,
      email,
      pincode,
      professionType,
      dob,
      mobile,
      mobiletncchecked: true,
      mobiletnctime: new Date().toISOString(),
    }));

    toast.success("Form data updated successfully");

    // Step 4: Mark form as started

    // Step 5: Move to next step
    setCurrentStep((prev) => prev + 1);
  };

  useEffect(() => {
    console.log("Consent checked updated:", isConsentChecked);
  }, [isConsentChecked]);

  const handleValidation = () => {
    setShowErrors(true); // enables red borders

    const newErrors = {};

    if (!gender) newErrors.gender = true;
    if (!name.trim()) newErrors.name = true;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = true;
      setIsEmailValid(false);
    }
    if (!/^\d{10}$/.test(mobile)) {
      newErrors.mobile = true;
      setIsMobileValid(false);
    }
    if (!pincode.match(/^\d{6}$/)) newErrors.pincode = true;
    if (!professionType) newErrors.professionType = true;
    if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pancard)) {
      newErrors.pancard = true;
      setIsPanValid(false);
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return (
    <div>
      <div className="w-full mb-3 flex font-polysans -mt-3  justify-center items-center gap-2 text-[#818181] ">
        <div className="flex items-center gap-3 w-full px-2.5 max-w-fit mx-auto border">
          <div className="w-10 border-t border-gray-500"></div>
          <h1 className="text-[clamp(1rem,5vw,20px)] font-atkinson-bold text-black">
            Personal information
          </h1>
          <div className="w-10 border-t border-gray-500"></div>
        </div>
      </div>

      <div className="flex flex-wrap gap-2 mb-3 items-center justify-center">
        {/* Male Button */}
        <button
          className={`flex items-center justify-center w-[165px] xs:w-[150px] sm:w-[165px] h-[55px] sm:h-[55px] border-[1px] rounded-md text-base cursor-pointer font-atkinson transition-colors duration-200 ${
            gender === "Male" || gender === "male"
              ? "bg-neutral-900 text-green-400 border-neutral-900"
              : "bg-white text-black border-gray-400 hover:bg-gray-100"
          }`}
          onClick={() => setGender("Male")}
        >
          <div className="flex items-center gap-2">
            <img
              src={
                gender === "Male" || gender === "male"
                  ? "/assets/img/Male_green.svg"
                  : "/assets/img/Male_black.svg"
              }
              alt="Male Icon"
              className="h-5"
            />
            <span>Male</span>
          </div>
        </button>

        {/* Female Button */}
        <button
          className={`flex items-center justify-center w-[165px] xs:w-[150px] sm:w-[165px] h-[55px] sm:h-[55px] border-[1px] rounded-md text-base cursor-pointer font-atkinson transition-colors duration-200 ${
            gender === "Female" || gender === "female"
              ? "bg-neutral-900 text-green-400 border-neutral-900"
              : "bg-white text-black border-gray-400 hover:bg-gray-100"
          }`}
          onClick={() => setGender("Female")}
        >
          <div className="flex items-center gap-2">
            <img
              src={
                gender === "Female" || gender === "female"
                  ? "/assets/img/Female_green.svg"
                  : "/assets/img/Female_black.svg"
              }
              alt="Female Icon"
              className="h-5"
            />
            <span>Female</span>
          </div>
        </button>
      </div>

      <FormInputStyle4
        label="Full Name as per Pan Card"
        value={name}
        onChange={(e) => setName(e.target.value)}
        isValid={!errors.name}
        errorMessage="Name is required"
      />
      <FormInputStyle4
        type="date"
        label="Date of Birth"
        value={dob}
        onChange={(e) => setDob(e.target.value)}
        isValid={!errors.dob}
        errorMessage="Date of birth is required"
      />
      <FormInputStyle4
        label="Mobile Number"
        value={mobile}
        isValid={isMobileValid}
        minLength="10"
        maxLength="10"
        pattern="[0-9]{10}"
        inputMode="numeric"
        onChange={handleMobileChange}
        errorMessage="Mobile Number is required"
      />
      <FormInputStyle4
        label="Personal Email Address"
        value={email}
        onChange={handleEmailChange}
        isValid={isEmailValid}
        errorMessage="Enter a valid email"
      />
      <FormInputStyle4
        type="text"
        name="pancard"
        isValid={isPanValid}
        id="pancard"
        minLength="10"
        maxLength="10"
        value={pancard}
        onChange={handlePanChange}
        required
        label={"PAN Card Number"}
        inputMode="text"
        errorMessage={"Please enter a valid PAN Number"}
      />
      <FormInputStyle4
        label="Home Pin Code"
        value={pincode}
        onChange={(e) => {
          const value = e.target.value;
          if (/^\d{0,6}$/.test(value)) {
            setPincode(value);
            if (errors.pincode) {
              setErrors((prev) => ({ ...prev, pincode: false }));
            }
          }
        }}
        onBlur={() => {
          if (!pincode.match(/^\d{6}$/)) {
            setErrors((prev) => ({ ...prev, pincode: true }));
          }
        }}
        isValid={!errors.pincode}
        errorMessage="Enter 6-digit pincode"
        tick={pincode.length === 6}
      />
      <FormSelectStyle4
        label="Occupation"
        value={professionType}
        onChange={handleProfessionChnage}
        onBlur={() => {
          if (!professionType) {
            setErrors((prev) => ({ ...prev, professionType: true }));
          }
        }}
        options={[
          { label: "Salaried", value: "salaried" },
          { label: "Self-Employed", value: "self_employed" },
          // { label: "Business Owner", value: "business owner" },
        ]}
        isValid={!errors.professionType}
        errorMessage="Please select professionType"
      />

      <div className="flex mx-auto w-[85%] gap-2">
        <CustomCheckbox
          checked={isConsentChecked}
          setchecked={setIsConsentChecked}
        />
        <p className="text-[7px] font-atkinson text-[#B3B3B3] leading-[9px]">
          I agree that the loan applied for from {" "}
          <a
            href="lending-partners"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#0077FF] text-[9px]"
          >
            Lending Partners{" "}
          </a>{" "}
          will be governed by the
          <a href="privacy-policy" target="_blank" className="text-[#0077FF] text-[9px]">
            Terms &amp; Conditions
          </a>{" "}
          .
           I declare that my gross household income is greater than Rs.
          25,000 per month. To process my application, I give my explicit
          consent to DigitMoney &amp; its Lending Partners to obtain my credit
          report(s) from credit bureaus, to fetch required information for KYC
          from approved agencies including UIDAI, to reach out to me with
          personalized offers on products &amp; services through SMS, WhatsApp,
          RCS, Email and telephonic calls/bots and this consent will override
          any registration for DND and/or NDNC.
        </p>
      </div>

      <FormButtonStyle4
        className="mt-3"
        text="Continue"
        disabled={!isFormValid}
        isLoading={isLoading}
        onClick={handleValidateAndUpdateForm}
      />
    </div>
  );
}

export default PersonalDetailsForm;
